import type { Location, NavigateFunction } from 'react-router-dom';

type PathState = {
    nextPathname?: string;
};

type NavOptions = {
    replace?: boolean;
    state?: unknown;
};

let _navigate: NavigateFunction | null = null;
let _location: Location | null = null;

export function setNavigation(navigate: NavigateFunction, location: Location) {
    _navigate = navigate;
    _location = location;
}

function ensureNavigate(): NavigateFunction {
    if (!_navigate) {
        throw new Error(
            'Navigation not initialized yet. Render <NavigationRegistrar /> inside <BrowserRouter> first.'
        );
    }
    return _navigate;
}

export function getCurrentPathState(): PathState | null {
    return (_location?.state as PathState | null) ?? null;
}

export function goBack() {
    ensureNavigate()(-1);
    window.scrollTo(0, 0);
}

export function goTo(target: string, options?: NavOptions) {
    ensureNavigate()(target, options);
    window.scrollTo(0, 0);
}

export function goToActivate() {
    goTo('/registration/activate');
}

export function goToDashboard() {
    goTo('/dashboard');
}

export function goToLocation(
    mansionId: string | number,
    locationId: string | number
) {
    goTo(`/objects/${mansionId}/${locationId}`);
}

export function goToLogin() {
    goTo('/login');
}

export function goToMansion(mansionId: string | number) {
    goTo(`/objects/${mansionId}`);
}

export function goToMansionOverview() {
    goTo('/objects');
}

export function goToPasswordReset() {
    goTo('/password-reset/request');
}

export function goToSelectPartner() {
    goTo('/select-partner');
}

export function goToCreatePartner() {
    goTo('/create-partner');
}

export function goToManageAccount() {
    goTo('/manage-account');
}

export function goToOperationalContact(operationalContactId: string | number) {
    goTo(`/operational-contacts/${operationalContactId}`);
}

export function goToOperationalContactOverview() {
    goTo('/operational-contacts');
}

export function goToEndOfLogin(
    accountingAreaCount: number,
    canCreateAccountingAreas: boolean
) {
    const storedRedirect = getCurrentPathState()?.nextPathname;

    if (accountingAreaCount === 0 && canCreateAccountingAreas) {
        goToCreatePartner();
    } else if (storedRedirect) {
        goTo(storedRedirect);
    } else if (accountingAreaCount === 1) {
        goToDashboard();
    } else {
        goToSelectPartner();
    }
}
